export const OFFICE_SUITE_VALUE = '21-50';
const OFFICE_SUITE_LOW_END = '21';
export const CUSTOM_BUILDOUT_VALUE = '51-500';
export const CUSTOM_BUILDOUT_LOW_END = '51';
export const ENTERPRISE_VALUE = '500+';
const ENTERPRISE_LOW_END = '500';
export const MAX_SHOWN_BUILDINGS_COUNT = 100;

export const SPECIAL_CAPACITIES_MAP = {
  [CUSTOM_BUILDOUT_VALUE]: CUSTOM_BUILDOUT_LOW_END,
  [ENTERPRISE_VALUE]: ENTERPRISE_LOW_END,
  [OFFICE_SUITE_VALUE]: OFFICE_SUITE_LOW_END
};
